export const LikedVia = {
	"GLOBAL": "GLOBAL",
	"ESSAY": "ESSAY",
	"PHOTO": "PHOTO",
};



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/constants.js